/**
 * ICON转换库 国际化
 */
export default {
  carrierType: {
    incubator: 'Incubator',
    refrigerator: 'Refrigerator',
    vehicle: 'Vehicle',
    refrigeratory: 'Cold Storage'
  },
  abnormal: {
    sensorConnect: 'Sensor Connection Abnormal',
    sensorTemp: 'Sensor Temperature Abnormal',
    sensorHum: 'Sensor Humidity Abnormal',
    gatewayConnect: 'Gateway Connection Abnormal',
    gatewayBlackout: 'Gateway Power Outage Abnormal',
    displayConnect: 'Abnormal display connection',
    relayConnect: 'Repeater Connection Abnormal',
    relayRetain: 'Retain Exception'
  },
  carrierStatus: {
    running: 'Running',
    obsolete: 'Scrapped',
    spare: 'Spare',
    require: 'Pending Repair',
    defrost: 'Defrost'
  },
  equiStatus: {
    offline: 'Offline',
    running: 'Running',
    stop: 'Deactivate'
  },
  isAbnormal: {
    normal: 'Normal',
    abnormal: 'Device Abnormal'
  },
  isCarrierAbnormal: {
    normal: 'Normal',
    abnormal: 'Abnormal',
    stop: 'Stop'
  },
  sensorType: {
    ZigBeeTemp: 'ZigBee Temperature Sensor',
    ZigBeeTempHum: 'Zigbee Temp.&RH Sensor',
    LoraTemp: 'Lora Temperature Sensor',
    LoraTempHum: 'Lora Temp.&RH Sensor',
    ZetaTemp: 'Zeta Temperature Sensor',
    ZetaTempHum: 'Zeta Temp.&RH Sensor',
    ZigBee2Temp: 'Gen2 ZigBee Temperature Sensor',
    ZigBee2TempHum: 'Gen2 ZigBee Temp&RH Sensor',
    FourGTemp: '4G Temperature Sensor',
    FourGTempHum: '4G Temp.  RH Sensor',
    FourGTempGps: '4G Temperature Sensor with GPS',
    FourGTempHumGps: '4G Temp.  RH Sensor with GPS'
  },
  configStatus: {
    wait: 'Pending Configuration',
    configuring: 'Configuring',
    configured: 'Configured',
    fail: 'Setting Failed'
  },
  gatewayType: {
    gw1: 'Gateway V1.0',
    gw1GPS: 'Gateway V1.0 with GPS',
    gw2: 'Gateway V2.0',
  },
  displayType: {
    dsp1: 'Display V1.0'
  },
  relayType: {
    relay1: 'Repeater V1.0'
  },
  equiType: {
    sensor: 'Sensor',
    gateway: 'Gateway',
    display: 'Show Label',
    relay: 'Repeater',
    gas: 'Gas',
    magnetism: 'Door Sensor',
    air: 'Air',
    base: 'Smart Base',
  },
  gasType: {
    '0x00': 'Smoke/Propane',
    '0x01': 'Methane Gas',
    '0x04': 'Carbon Monoxide',
    '0x0A': 'Propane Gas(C3H8)',
    '0x32': 'Methane/Propane/Isobutane',
    'gs_6': 'Carbon Dioxide'
  },
  magnetismType: {
    m1: 'Door Seneor V1.0'
  },
  baseType: {
    bt_915: 'Bracket of 915 Series',
    bt_433: 'Bracket of 433 Series',
    bt_g: 'Bracket of 2.4G Series',
    bt_4g: 'Bracket of 4G Series',
    pt_1: 'Bracket',
    pt_2: 'RH Sensor Bracket',
  },
  // 设备是否可跟踪
  traceOn: 'Yes',
  traceOff: 'No',
  // 分析项图标
  analEx: 'Exception',
  analAlarm: 'Alarm',
  analNormalAbnormal: 'Normal/Abnormal',
  analOffline: 'Offline',
  analConfigure: 'Configure',
  analPowerout: 'Power Outage',
  // 下载状态
  generating: 'Generating',
  generated: 'Generated',
  genFail: 'Generate Failed'
}
